/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface CrmPropPesponse
 */
export class CrmPropPesponse {
    /**
     *
     * @type {string}
     * @memberof CrmPropPesponse
     */
    type?: CrmPropPesponseTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CrmPropPesponse
     */
    name?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum CrmPropPesponseTypeEnum {
    Solution = 'SOLUTION',
    Entity = 'ENTITY',
    EntityConfig = 'ENTITY_CONFIG',
    Method = 'METHOD',
    Version = 'VERSION',
}
